
const ifFieldIsEmpty = ($target, value, parentClass) => {
    let parentContainer = false

    if ($target.parentNode.classList.contains(parentClass))
      parentContainer = true

    if (value === "" || value === null || value === 'undefined') {
      (parentContainer) ? $target.parentNode.classList.remove('filled') : null
      $target.classList.remove('filled')
    } else {
      (parentContainer) ? $target.parentNode.classList.add('filled') : null
      $target.classList.add('filled')
    }
  }

class forms {
    process(parentClass) {
      const $fields = document.querySelectorAll('input, select, textarea')

      if ($fields.length <= 0 || $fields === null || typeof $fields === 'undefined')
        return false

      $fields.forEach(($item, i) => {
        ifFieldIsEmpty($item, $item.value, parentClass)

        $fields[i].addEventListener('change', (e) => {
          ifFieldIsEmpty(e.target, e.target.value, parentClass)
        })
      })

    }
    init(parentClass = 'input-field') {
      window.addEventListener('load', () => {
        this.process(parentClass)
      })
    }
  }

  export default forms
